import { createContext, type Dispatch, type SetStateAction } from 'react';

import noop from 'lodash/noop';

export const WillRedirectOnLoadContext = createContext(false);
export const SetWillRedirectOnLoadContext = createContext<Dispatch<SetStateAction<boolean>>>(noop);
